import {computed, defineComponent, PropType} from 'vue';
import {RouteRecordRaw} from 'vue-router';
import DateUtil from "@/app/shared/helpers/date-util";

export interface MapRequestCard {
    id: string;
    type: string;
    reference: string;
    status: string;
    dateReceived?: string;
    startDate?: string;
    mapRequestType?: string | undefined;
    organisation?: string | undefined;
    processingLabel?: string;
}

export default defineComponent({
    name: 'KlMapRequestCard',
    methods: {
        DateUtil() {
            return DateUtil
        }
    },
    props: {
        mapRequestCard: {
            type: Object as PropType<MapRequestCard>,
            required: true,
        },
        to: {
            type: Object as () => RouteRecordRaw,
            required: true,
        },
    },
    setup(props) {
        const requestType = computed(() => {
            return props.mapRequestCard.mapRequestType === 'Raadpleging voor uitvoering grondwerken' ? 'Werken' : 'Studiefase';
        });

        const isProcessingCard = computed((): boolean => props.mapRequestCard?.type === 'processing');

        return {
            requestType,
            isProcessingCard,
        };
    }
});
